import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppState } from '../app.service';
import { SeoService, EducatorsResourcesService } from '../_services';
import { PortalLinkDialogComponent } from '../home/portal';
import { MatDialog } from '@angular/material/dialog';

declare var dataLayer: any;

@Component({
  selector: 'pq-educators',
  templateUrl: './educators.component.html',
  styleUrls: ['./_educators.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EducatorsComponent implements OnInit {
  public title: string = "Educators' Resources";
  public showCAPTCHA: boolean = this.appState.get('sessionType') === 'USERNAMEPASS';
  public productName: string = this.appState.get('displayname');
  public resourceLinks: object[] = [];
  public loading: boolean = true;
  public error: boolean = false;

  constructor (
    public appState: AppState,
    private _seoSvc: SeoService,
    private _educatorsResourceSvc: EducatorsResourcesService,
    private _dialog: MatDialog,
  ) {
    this._seoSvc.setTitle(this.title);
  }

  public ngOnInit (): void {
    const request = this._educatorsResourceSvc.get(this.appState.get('current_profile'));

    this.error = false;
    this.loading = true;

    request.catch((err: any) => {
      this.error = true;
      this.loading = false;
    });

    request.then((resp: object) => {
      let links = (resp['EducatorsResources'] && resp['EducatorsResources']['links']) ? resp['EducatorsResources']['links'] : [];
      this.loading = false;

      if (resp['EducatorsResources'] && links.length) {
        this.error = false;
        // update platform url to be the current environment url
        links.forEach((link) => {
          if (link['type'] === 'platformBrowse') {
            // get the token from the platform url and reuse it for other platform url so they are authenticated
            const token = this.appState.get('platformUrl')  && (this.appState.get('platformUrl').split('?')[0].split('/embedded/').length === 2) ? this.appState.get('platformUrl').split('/embedded/')[1] : undefined;
            link['titleUrl'] = this.appState.get('platformUrlPrefix') + link['titleUrl'];
            if (token && link['titleUrl'].indexOf('/embedded') === -1) {
              link['titleUrl'] = link['titleUrl'] + '/embedded/' + token;
            }
          }
        });

        this.resourceLinks = links;
      } else {
        this.error = true;
      }
    });
  }

  public getPlatformUrl (): string {
    return this.appState.get('platformUrl') || '';
  }

  public getProductPlatformUrl (): string {
    const token = this.appState.get('platformUrl')  && (this.appState.get('platformUrl').split('?')[0].split('/embedded/').length === 2) ? this.appState.get('platformUrl').split('/embedded/')[1] : undefined;
    let url = this.appState.get('platformUrlPrefix') + '/' + this.appState.get('moniker')  + '/embedded/' + token ;
    return url;
  }

  public pushEducatorsClickToGA (label: String) {
    if (dataLayer && Array.isArray(dataLayer)) {
      dataLayer.push({
        'event': 'HomeNavigation',
        'category': 'Educators Resources',
        'label': label
      });
    }
  }

  public handleCAPTCHACheck (url?: string): void {
    const productPlatformValue = 'proquest';
    this._dialog.open(PortalLinkDialogComponent, {
      disableClose: true,
      data: {
        profile: this.appState.get('current_profile'),
        platform: productPlatformValue,
        url: url
      }
    });
  }
}
